import _ from 'lodash';

export const formatAppraiser = (appraiser) => {
  const attributes = {};
  const relationships = {};
  const id = appraiser.id && appraiser.id !== 'dummy' ? appraiser.id : undefined;

  if (_.has(appraiser, 'nombre') && _.has(appraiser, 'apellidos')) {
    if (!_.isNil(appraiser.nombre) && !_.isNil(appraiser.apellidos)) {
      attributes.title = `${appraiser.nombre} ${appraiser.apellidos}`;
    } else if (!_.isNil(appraiser.nombre)) {
      attributes.title = `${appraiser.nombre}`;
    } else {
      attributes.title = `Appraiser - ${Date.now()}`;
    }
  } else {
    attributes.title = `Appraiser - ${Date.now()}`;
  }
  if (appraiser.nombre) {
    attributes.appraiser_name = appraiser.nombre;
  }
  if (appraiser.apellidos) {
    attributes.appraiser_surname = appraiser.apellidos;
  }
  return {
    data: {
      id,
      type: 'node--appraiser',
      attributes,
      relationships,
    },
  };
};

export const processAppraiser = (appraiser) => {
  const { attributes, id, type } = appraiser;
  const appraiserModel = { id, type };
  if ('title' in attributes) {
    appraiserModel.title = attributes.title;
  }
  if ('appraiser_name' in attributes) {
    appraiserModel.nombre = attributes.appraiser_name;
  }
  if ('appraiser_surname' in attributes) {
    appraiserModel.apellidos = attributes.appraiser_surname;
  }
  return appraiserModel;
};

export const processAppraiserResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(ajd =>
      processAppraiser(ajd));
  }
  return processAppraiser(res.data.data);
};



// WEBPACK FOOTER //
// ./src/features/appraiser/utils.js